import AssistantApi from './AssistantApi';
export default AssistantApi;
